import React from 'react';
import GeoMapWithTiles from '../../../features/geo-map/GeoMapWithTiles';
import style from './styles.module.css';
import MapContainer from './styles/MapContainer';
import { useAppSelector } from '../../../app/store';
import reducerPath from '../../../app/reducerPath';
import mapNames from '../../../entities/map/constants';

function CoverageMap() {
  const mapName = mapNames.coverage;
  const isFullScreen = useAppSelector((state) => state[`${reducerPath.fullScreenMap}`])[mapName];

  return (
    <MapContainer isFullScreen={isFullScreen}>
      <GeoMapWithTiles
        name={mapName}
        styles={isFullScreen ? style.fullGeoMap : style.geoMap}
        isOffButtonFollowMode
        isOnCoverageLayer
      />
    </MapContainer>
  );
}

export default CoverageMap;
